import {uuid} from '@sanity/uuid'

export function createTransactionId() {
  return uuid()
}
